export default __webpack_public_path__ + "static/media/upload.e7f7bdd8.svg";